export enum ETabs {
  Realtors = 'realtors',
  Agencies = 'agencies',
}
